/* Toggle .header--scrolled past the hero AND .header--mega-open
   when the Products dropdown is hovered/focused. */

(function () {
    const header = document.querySelector('.header');
    if (!header) return;

    /* ---------- Scroll past hero ---------- */

    const hero = document.querySelector('.hero');
    let trigger = hero ? Math.round(hero.offsetHeight * 0.8) : 400;

    function updateScroll() {
        if (window.scrollY >= trigger) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }
    }

    let raf;
    window.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
            updateScroll();
            raf = null;
        });
    }, { passive: true });

    window.addEventListener('resize', function () {
        if (hero) trigger = Math.round(hero.offsetHeight * 0.8);
        updateScroll();
    });

    updateScroll();


    /* ---------- Mega-open hover state ---------- */

    const wrap = document.querySelector('.header__dropdown-wrap');
    const drop = document.querySelector('.header__dropdown');
    if (!wrap || !drop) return;

    let closeTimer = null;

    function openMega() {
        clearTimeout(closeTimer);
        header.classList.add('header--mega-open');
    }

    function closeMega() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
            header.classList.remove('header--mega-open');
        }, 120);
    }

    wrap.addEventListener('mouseenter', openMega);
    wrap.addEventListener('mouseleave', closeMega);
    drop.addEventListener('mouseenter', openMega);
    drop.addEventListener('mouseleave', closeMega);

    wrap.addEventListener('focusin', openMega);
    wrap.addEventListener('focusout', function (event) {
        if (!wrap.contains(event.relatedTarget)) closeMega();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            clearTimeout(closeTimer);
            header.classList.remove('header--mega-open');
        }
    });
})();
